import { memo } from 'react'
import PasswordField from '@src/Components/PasswordField'
import { Button, Dialog, DialogContent, DialogHeader, DialogTitle, XCloseIcon } from '@wove/web-ui'

interface ChangePasswordModalProps {
  onClose: () => void
  isOpen: boolean
}
const ChangePasswordModal = memo(({ onClose, isOpen }: ChangePasswordModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px] max-w-[95vw] max-h-[90vh] overflow-y-auto bg-white p-8">
        <DialogHeader className="flex items-center justify-between">
          <DialogTitle className="text-lg sm:text-xl">Change your account password</DialogTitle>
          <XCloseIcon
            className="cursor-pointer w-7 h-7 text-muted-foreground hover:text-foreground"
            onClick={onClose}
          />
        </DialogHeader>
        <div className="py-3">
          <PasswordField label="Current Password" autoFocus className="mb-5" />
          <PasswordField label="New Password" className="mb-5" />
          <PasswordField label="New Password Confirmation" className="mb-5" />
          <Button variant="default" className="w-full">
            Continue
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
})

export default ChangePasswordModal
